import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useLanguage } from '../../contexts/LanguageContext';

const CookiePolicyNav = () => {
  const { t } = useLanguage();
  const [activeSection, setActiveSection] = useState('introduction');

  const navItems = [
    { id: 'introduction', label: t('cookies.policy.nav.introduction') },
    { id: 'categories', label: t('cookies.policy.nav.categories') },
    { id: 'cookies-we-use', label: t('cookies.policy.nav.cookiesWeUse') },
    { id: 'google-analytics', label: t('cookies.policy.nav.googleAnalytics') },
    { id: 'your-choices', label: t('cookies.policy.nav.yourChoices') },
    { id: 'contact', label: t('cookies.policy.nav.contact') },
  ];

  // Track active section on scroll
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.st-cookie-policy-section');
      const scrollPos = window.scrollY + 150;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="st-cookie-policy-nav st-sticky">
      <h3 className="st-cookie-policy-nav-title">{t('cookies.policy.nav.title')}</h3>
      <ul className="st-cookie-policy-nav-list">
        {navItems.map((item) => (
          <li key={item.id}>
            <ScrollLink
              to={item.id}
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              className={activeSection === item.id ? 'active' : ''}
              onSetActive={() => setActiveSection(item.id)}
            >
              {item.label}
            </ScrollLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default CookiePolicyNav;
